import { render, staticRenderFns } from "./ApiTokensModal.vue?vue&type=template&id=7227feda&"
import script from "./ApiTokensModal.vue?vue&type=script&lang=js&"
export * from "./ApiTokensModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports